import './progress-loading.less';
import classNames from 'classnames';
import { useLocaleStore } from '@/i18n';
import { useFramework } from '../../hooks';

interface ProgressLoadingProps {
    progress: number; // 进度值 0-99.99
    baseTime: number; // 基准时间（分钟）
    scale?: number;
    blur?: number;
    borderRadius?: number;
    isTextLayer?: boolean;
    hideText?: boolean;
    hideProgress?: boolean;
    textOnly?: boolean; // 新增：是否只显示纯文本进度
}

const ProgressLoading = ({
    progress,
    baseTime,
    scale = 1,
    blur = 10,
    borderRadius,
    isTextLayer = false,
    hideText = false,
    hideProgress = false,
    textOnly = false,
}: ProgressLoadingProps) => {
    const { $t } = useLocaleStore();
    const framework = useFramework();
    const isEdgelessMode = framework.service.edgelessCanvas.isEdgelessMode;

    // 确保进度值在有效范围内
    const clampedProgress = Math.max(0, Math.min(99, progress));
    // 转换为 0-1 的范围用于计算宽度
    const progressValue = clampedProgress / 100;

    const progressText = clampedProgress.toString();

    // 进度条宽度：64px，进度部分宽度根据进度值计算
    const progressBarWidth = 64;
    const progressWidth = progressBarWidth * progressValue;

    return (
        <>
            <div
                style={
                    {
                        '--backdrop-filter-blur': `${Math.max(blur, 8)}px`,
                        borderRadius,
                    } as React.CSSProperties
                }
                className={classNames('layer-loading-wrap', {
                    'edgeless-mode': isEdgelessMode && !isTextLayer,
                })}
            >
                <div className={classNames('progress-loading')} style={{ transform: `scale(${scale})` }}>
                    {!hideProgress && (
                        <div className="progress-loading-bar">
                            <div className="progress-loading-bar-bg" />
                            <div className="progress-loading-fill" style={{ width: `${progressWidth}px` }} />
                        </div>
                    )}
                    {!hideText && (
                        <div className="progress-loading-text-wrap">
                            {textOnly ? (
                                <span className="progress-loading-percent">
                                    {progressText}%<span className="progress-loading-dots"></span>
                                </span>
                            ) : (
                                <>
                                    <span className="progress-loading-percent">{progressText}%</span>
                                    <span className="progress-loading-text">
                                        {$t((v, { r }) => r(v.Tip_EstimatedTime, [baseTime]))}
                                    </span>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ProgressLoading;
